import { Modal } from "@mui/material";
import "./styles.css";
import { DataGrid } from "@mui/x-data-grid";
const DSApprovedModal = ({ open = true, data = [], close }) => {
  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
  const columns = [
    { field: "qty", headerName: "Quantity", flex: 0.5 },
    { field: "refund_amount", headerName: "Refund Amount", flex: 1 },
    { field: "loc", headerName: "Location", flex: 0.5 },
    { field: "bill_no", headerName: "Bill No", flex: 1 },
    { field: "request_id", headerName: "Request ID", flex: 1 },
    {
      field: "reason",
      headerName: "Reason",
      flex: 1,
      renderCell: (params) => (
        <div
          title={params.value}
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}>
          {params.value}
        </div>
      ),
    },
  ];

  return (
    <Modal open={open}>
      <div className="approved-main">
        <div className="approved-container">
          {/* Header  */}
          <div className="approved-header">
            <span>Approved Logs</span>
            <button className="dsRequestCloseBtn" onClick={close}>
              Close
            </button>
          </div>
        </div>
        <div className="approved-container">
          {data?.length === 0 ? (
            <div className="approved-no-data">
              <div>No data available</div>
            </div>
          ) : (
            <div className="approved-grid-wrapper ">
              <DataGrid
                rows={data}
                columns={columns}
                hideFooter
                disableRowSelectionOnClick
                rowHeight={42}
                getRowId={(row) => generateRandom()}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    overflowY: "auto", // ensure scroll happens here
                  },
                }}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DSApprovedModal;
